import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import { ViewModeEnum, AlertDialogTypeEnum } from '../../../../_enums/_index';
import { DealTermModel } from '../../../../_models/_index';

@Component({
    selector: 'app-deal-terms-item-dialog',
    templateUrl: './deal-terms-item-dialog.component.html',
    styleUrls: ['./deal-terms-item-dialog.component.css']
})
export class DealTermsItemDialogComponent implements OnInit {
    dialogHeader: string;
    viewMode: ViewModeEnum;
   dealTerms: DealTermModel = new DealTermModel();

    constructor(private dialog: MatDialog,
        public dialogRef: MatDialogRef<DealTermsItemDialogComponent>) { }

  ngOnInit() {
  }

  getSaveText() {
      switch (this.viewMode) {
          case ViewModeEnum.Add:
              return "הוסף";
          case ViewModeEnum.Edit:
              return "עדכן";
      }
  }

  save() {
      if (this.viewMode == ViewModeEnum.Add) {
          this.addDealTerms();
      }
      else {
          this.editDealTerms();
      }
  }

  private addDealTerms() {
      this.dialogRef.close(this.dealTerms);
  }

  private editDealTerms() {
      this.dialogRef.close(this.dealTerms);
  }

  private isEditMode() {
      return this.viewMode == ViewModeEnum.Edit;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/deal-wizard/deal-package/deal-terms-item-dialog/deal-terms-item-dialog.component.ts